export const MENUS = {
    DASHBOARD: 'dashboard',
    CADASTRO: 'cadastro',
    FUNCIONALIDAES: 'funcionalidades',
    FINANCEIRO: 'financeiro',
    SISTEMA: 'sistema',
    AREA_CLIENTE: 'areaCliente'

}
